import React, { useEffect, useState } from "react";
import { Button, Carousel, Container } from "react-bootstrap";
import { Input, message } from "antd";
import axios from "axios";
import { API_URL } from "../API/config";
import Cards from "./Card";

interface Product {
  // Define the product structure if needed
}

export default function DealofWeek() {
  const [data, setData] = useState<Product[]>([]);
  const [bannerData, setBannerData] = useState<any[]>([]);
  const [bannerFestData, setBannerFestData] = useState<any[]>([]);
  const [messageApi, contextHolder] = message.useMessage();

  const success = (content: any) => {
    messageApi.open({
      type: "success",
      content: content,
      className: "custom-class",
    });
  };

  const errormessage = (content: any) => {
    messageApi.open({
      type: "error",
      content: content,
      className: "custom-class",
    });
  };

  const copyToClipboard = (data: string) => {
    navigator.clipboard
      .writeText(data)
      .then(() => success("Copied!"))
      .catch((error) => {
        errormessage("Failed to copy coupon code!");
      });
  };

  const getProduct = async () => {
    const token = sessionStorage.getItem("token");

    try {
      const res = await axios.get(`${API_URL}/api/products`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const bestProd = res.data.filter((val: any) => val.rating >= 4);
      setData(bestProd);
      await getofferBanner();
    } catch (error) {
      errormessage(error);
    }
  };

  const getofferBanner = async () => {
    const token = sessionStorage.getItem("token");

    try {
      const res = await axios.get(`${API_URL}/api/banner/offerBanners`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const filteredBanners = res.data.banners.filter(
        (val: any) => val.actionButton
      );
      setBannerData(filteredBanners);
      await getfestivalBanner();
    } catch (error) {
      errormessage(error);
    }
  };

  const getfestivalBanner = async () => {
    const token = sessionStorage.getItem("token");

    try {
      const res = await axios.get(`${API_URL}/api/banner/festivalBanners`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const filteredBanners = res.data.banners.filter(
        (val: any) => val.actionButton
      );
      setBannerFestData(filteredBanners);
    } catch (error) {
      errormessage(error);
    }
  };

  useEffect(() => {
    getProduct();
  }, []);

  return (
    <>
      <Container>
        {contextHolder}
        {/* <section className="dealofweek py-4">
        {bannerData.length > 1 ? (
          <Carousel>
            {bannerData.map((val, i) =>
              val && val.image ? (
                <Carousel.Item key={i}>
                  {val.link ? (
                    <a
                      href={val.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        className="img-fluid"
                        src={`${API_URL}/images/${val.image}`}
                        style={{ cursor: "pointer" }}
                        alt={`Banner ${i + 1}`}
                      />
                    </a>
                  ) : (
                    <img
                      className="img-fluid"
                      src={`${API_URL}/images/${val.image}`}
                      style={{ cursor: "pointer" }}
                      onClick={() => copyToClipboard(val.couponCode)}
                      alt={`Banner ${i + 1}`}
                    />
                  )}
                </Carousel.Item>
              ) : null
            )}
          </Carousel>
        ) : bannerData[0] && bannerData[0].image ? (
          <div>
            {bannerData[0].link ? (
              <a
                href={bannerData[0].link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="img-fluid"
                  src={`${API_URL}/images/${bannerData[0].image}`}
                  style={{ cursor: "pointer" }}
                  alt="Banner"
                />
              </a>
            ) : (
              <img
                className="img-fluid"
                src={`${API_URL}/images/${bannerData[0].image}`}
                style={{ cursor: "pointer" }}
                onClick={() => copyToClipboard(bannerData[0].couponCode)}
                alt="Banner"
              />
            )}
          </div>
        ) : null}
      </section> */}
        {data.length > 0 && (
          <section className="dealofweek py-4">
            <Container>
              <div className="pb-3 pt-5">
                <h2 className="head-txt-1">
                  <span>Bestselling</span> Of Products
                </h2>
              </div>
              <div className="row py-3">
                <Cards product={data.slice(-6)} />
              </div>
            </Container>
          </section>
        )}

        <section className="dealofweek py-4">
          {bannerFestData.length > 1 ? (
            <Carousel>
              {bannerFestData.map((val, i) =>
                val && val.image ? (
                  <Carousel.Item key={i}>
                    {val.link ? (
                      <a
                        href={val.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          className="img-fluid"
                          src={`${API_URL}/images/${val.image}`}
                          style={{ cursor: "pointer" }}
                          alt={`Festival Banner ${i + 1}`}
                        />
                      </a>
                    ) : (
                      <img
                        className="img-fluid"
                        src={`${API_URL}/images/${val.image}`}
                        style={{ cursor: "pointer" }}
                        onClick={() => copyToClipboard(val.couponCode)}
                        alt={`Festival Banner ${i + 1}`}
                      />
                    )}
                  </Carousel.Item>
                ) : null
              )}
            </Carousel>
          ) : bannerFestData[0] && bannerFestData[0].image ? (
            <div>
              {bannerFestData[0].link ? (
                <a
                  href={bannerFestData[0].link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="img-fluid"
                    src={`${API_URL}/images/${bannerFestData[0].image}`}
                    style={{ cursor: "pointer" }}
                    alt="Festival Banner"
                  />
                </a>
              ) : (
                <img
                  className="img-fluid"
                  src={`${API_URL}/images/${bannerFestData[0].image}`}
                  style={{ cursor: "pointer" }}
                  onClick={() => copyToClipboard(bannerFestData[0].couponCode)}
                  alt="Festival Banner"
                />
              )}
            </div>
          ) : null}
        </section>
      </Container>
    </>
  );
}
